import { render, staticRenderFns } from "./UserExperienceForm.vue?vue&type=template&id=4f23d06c&"
import script from "./UserExperienceForm.vue?vue&type=script&lang=js&"
export * from "./UserExperienceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports